export const environment = {
	/**
	 *  DEVELOPMENT ENVIRONMENT CONFIG
	 */
	production: false,
	name: 'development',
	portalApi: {
		uri: 'https://rk-api-dev.centralus.cloudapp.azure.com',
		scopes: ['api://5bfb997b-c4fc-48b9-9f49-7b9f9ad53b05/api.read']
	},
	netSuiteInstance: {
		subdomain: '1103055'
	},
	enverusConfig: { domain: 'app.' },
	msalConfig: {
		auth: {
			clientId: '69269602-5ead-4350-b359-08e90dd1e1d2',
			authority:
				'https://login.microsoftonline.com/6619310b-1063-40c1-bb9f-f71fd57e7c72',
			redirectUri: 'https://connect-dev.rksupply.net/login/callback',
			postLogoutRedirectUri: 'https://connect-dev.rksupply.net'
		},
		groups: {
			ar: '2763e862-0e7e-4d2d-85ad-910bd9b00220',
			capital: '4978915e-8390-452b-a68b-789fb8d7b59d',
			salesManager: 'e51f9de5-a48f-4151-893b-164df043c03a',
			test: 'a98dccea-b095-404a-84b4-cbf7a42c3e47'
		},
		// Sign-in names (UPN). partCodingUsers opens Part Coding.
		// partCodingAdmins opens Admin Part Coding. Someone who needs both is on both lists.
		users: {
			partCodingUsers: [
				'j.chen@rksupply.net',
				'benjamin.keeley@rksupply.net',
				'j.tate@rksupply.net',
				't.bailey@rksupply.net',
				'marcus.pando@rksupply.net',
				'jeff.langner@rksupply.net',
				'kyle.kirk@rksupply.net',
				'aaron.clements@rksupply.net',
				'colby@rksupply.net'
			],
			partCodingAdmins: [
				'j.chen@rksupply.net',
				'benjamin.keeley@rksupply.net',
				'j.tate@rksupply.net',
				't.bailey@rksupply.net',
				'marcus.pando@rksupply.net',
				'jeff.langner@rksupply.net',
				'kyle.kirk@rksupply.net',
				'aaron.clements@rksupply.net',
				'colby@rksupply.net'
			]
		}
	}
};
